import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        // Store the token in localStorage
        const existingToken = localStorage.getItem('token');
        if (existingToken) {
          localStorage.removeItem('token');
        }
        this.validateAndRedirect(token);

      } else {
        // If no token in query params, try to use existing token
        const existingToken = localStorage.getItem('token');
        if (existingToken) {
          this.validateAndRedirect(existingToken);
        } else {
          this.router.navigate(['/auth/login']);
        }
      }
    });
  }

  private validateAndRedirect(token: string): void {
    this.authService.validateToken(token).subscribe({
      next: (isValid) => {
        if (isValid) {
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 1000);
        } else {
          localStorage.removeItem('token');
          this.router.navigate(['/auth/login']);
        }
      },
      error: () => {
        localStorage.removeItem('token');
        this.router.navigate(['/auth/login']);
      }
    });
  }
} 